export default __webpack_public_path__ + "static/media/img_misc_share.tab_heart.hands@2x.c8f88d1f.jpg";